module.exports = __webpack_public_path__ + "img/no-img.a929a480.png";